import { MapPin, MapPinOff } from 'lucide-react';
import { useState } from 'react';
import fieldStyles from './AddressField.module.css';
import { Button } from './Button';
import { PinDialog } from './map/PinDialog';

export interface Coords {
  lat: number;
  lng: number;
}

/** "Na mapie / Bez pinezki" with a button that opens the map to place or correct the pin. */
export function PinControl({ address, coords, onPin }: { address: string; coords: Coords | null; onPin: (c: Coords) => void }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={fieldStyles.pinRow}>
      {coords ? (
        <span className={fieldStyles.pinOk}>
          <MapPin aria-hidden="true" /> Na mapie
        </span>
      ) : (
        <span className={fieldStyles.pinMissing}>
          <MapPinOff aria-hidden="true" /> Bez pinezki
        </span>
      )}
      {address.trim().length >= 3 && (
        <Button variant="ghost" onClick={() => setOpen(true)}>
          {coords ? 'Popraw na mapie' : 'Znajdź na mapie'}
        </Button>
      )}
      {open && (
        <PinDialog
          open
          address={address}
          initial={coords}
          onClose={() => setOpen(false)}
          onSave={(p) => {
            onPin(p);
            setOpen(false);
          }}
        />
      )}
    </div>
  );
}
